export function devWarn(...args: Parameters<typeof console.warn>) {
  if (process.env.NODE_ENV === 'development') {
    console.warn(...args);
  }
}